import styled from '@emotion/styled';
import { tokens, Text } from '@hotjar/hotsauce';
import type { KeyboardEvent } from 'react';
import { useCallback } from 'react';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: calc(50% - 12px);

  @media (min-width: 1280px) {
    width: calc((100% - (24px * 2)) / 3);
  }

  &:focus {
    ${tokens.focus()};
  }
`;

const PreviewImage = styled.img`
  margin-bottom: ${tokens.spacer.x1};
  width: 100%;
`;

const TitleText = styled(Text)`
  margin-bottom: ${tokens.spacer.x0pt5};
`;

export interface SurveyTemplatesListItemProps {
  onClick: () => void;
  title: string;
  description: string;
  imageUrl: string;
  testIndex?: number;
}

export const SurveyTemplatesListItem = ({
  onClick,
  title,
  description,
  imageUrl,
  testIndex,
}: SurveyTemplatesListItemProps): JSX.Element => {
  const onKeyPress = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        onClick();
      }
    },
    [onClick],
  );

  return (
    <Container
      tabIndex={0}
      data-testid={testIndex === undefined ? undefined : `template-${testIndex}`}
      aria-label={title}
      role="button"
      onClick={onClick}
      onKeyPress={onKeyPress}
    >
      <PreviewImage src={imageUrl} alt="" />
      <TitleText textType="subtitle1">{title}</TitleText>
      <Text textType="body1" textColor="text_light">
        {description}
      </Text>
    </Container>
  );
};
